import { INew_TableAction } from '@lla-platform/core/core-data-access'
import { ISendAnnouncementRequest } from '../../interfaces/announcement.interface'

export class GetMyAnnouncements {
  static readonly type = '[announcements] Get My Announcements'
}

export class GetUnreadAnnouncementsCount {
  static readonly type = '[announcements] Get Unread Announcements Count'
}

export class MarkAnnouncementRead {
  static readonly type = '[announcements] Mark Announcement Read'
  constructor(public recipientId: string) {}
}

export class MarkAnnouncementUnread {
  static readonly type = '[announcements] Mark Announcement Unread'
  constructor(public recipientId: string) {}
}

export class ArchiveMyAnnouncement {
  static readonly type = '[announcements] Archive My Announcement'
  constructor(public recipientId: string) {}
}

export class UnarchiveMyAnnouncement {
  static readonly type = '[announcements] Unarchive My Announcement'
  constructor(public recipientId: string) {}
}

export class DeleteMyAnnouncement {
  static readonly type = '[announcements] Delete My Announcement'
  constructor(public recipientId: string) {}
}

export class SendAnnouncement {
  static readonly type = '[announcements] Send Announcement'
  constructor(public payload: ISendAnnouncementRequest) {}
}

export class GetAnnouncementUsers {
  static readonly type = '[announcements] Get Announcement Users'
}

export class GetAdminAnnouncements {
  static readonly type = '[announcements] Get Admin Announcements'
  constructor(public payload: INew_TableAction) {}
}

export class GetAdminAnnouncementDetail {
  static readonly type = '[announcements] Get Admin Announcement Detail'
  constructor(public id: string) {}
}

export class DeactivateAnnouncement {
  static readonly type = '[announcements] Deactivate Announcement'
  constructor(public id: string) {}
}
